import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../../../context/AuthContext";

const KycGate = () => {
  const { scoutData } = useAuth();
  const kycStatus = scoutData?.kyc_status;

  if (kycStatus && kycStatus !== "approved") {
    return <Navigate to="/scout/kyc" replace />;
  }

  return <Outlet />;
};

export default KycGate;
